import { Theme } from '@mui/material/styles';

type Color = {
	main: string;
	dark: string;
	light: string;
	contrastText: string;
};

const setShape = (shape: string) => {
	switch (shape) {
		case 'round':
			return 50;
		case 'sharp':
			return 0;
		default:
			return 3;
	}
};

export const HDMIconButton = {
	defaultProps: {
		color: 'default',
		shape: 'default',
	},
	styleOverrides: {
		root: ({
			ownerState,
			theme,
		}: {
			ownerState: { color: string; shape: string };
			theme: Theme;
		}) => {
			const color = ownerState.color as keyof typeof theme.palette | 'default';
			const shape = ownerState.shape as string | 'default';
			const defaultStyles = {
				width: 40,
				height: 40,
				borderRadius: setShape(shape),
				transition: 'all .2s ease',
				'& .MuiSvgIcon-root': {
					fontSize: 24,
				},
			};
			if (!color || color === 'default') {
				return {
					...defaultStyles,
					backgroundColor: theme.palette.background.paper,
					color: theme.palette.text.secondary,
					'&:hover': {
						backgroundColor: theme.palette.background.paper,
						border: `2px solid ${theme.palette.text.secondary}`,
					},
				};
			}

			const paletteColor = theme.palette[color] as Color;

			return {
				...defaultStyles,
				backgroundColor: paletteColor.main,
				color: paletteColor.contrastText,
				'&:hover': {
					backgroundColor: paletteColor.main,
					color: paletteColor.contrastText,
					filter: 'brightness(60%)',
				},
			};
		},
	},
	variants: [
		{
			props: { type: 'navigation' },
			style: ({
				ownerState,
				theme,
			}: {
				ownerState: { color: string; shape: string };
				theme: Theme;
			}) => {
				const color = ownerState.color as keyof typeof theme.palette | 'default';
				const shape = ownerState.shape as string | 'default';
				const defaultStyles = {
					width: 50,
					height: 50,
					borderRadius: setShape(shape),
					border: '2px solid transparent',
					transition: 'all .2s ease',
					'& .MuiSvgIcon-root': {
						fontSize: 24,
					},
				};

				if (!color || color === 'default') {
					return {
						...defaultStyles,
						color: theme.palette.grey[500],
						opacity: 0.6,
						'&:hover': {
							filter: 'brightness(100%)',
							opacity: 1,
						},
					};
				}
				const paletteColor = theme.palette[color] as Color;

				return {
					...defaultStyles,
					backgroundColor: paletteColor.main,
					color: paletteColor.contrastText,
					opacity: 0.6,
					'&:hover': {
						backgroundColor: paletteColor.main,
						color: paletteColor.contrastText,
						filter: 'brightness(100%)',
						opacity: 1,
					},
				};
			},
		},
	],
};
export const HDMContainer = {
	defaultProps: {
		maxWidth: '', // keep this config here to override OOB config
	},
};
